export default {
    show: false,
    mask: true
};



// WEBPACK FOOTER //
// ./src/ui/loading/store/state.js